/**
 * Creates property on NikeDotcomNav.components given the id passed in
 * Returns a function that can be used to apply the external data to the component
 * Please wait for mounted from OptionsContext to be true before calling this function
 * @param {string} id
 * @returns (component) => any
 */
const useExternalComponents = id => {
  // window undefined during ssr falling back to {}
  const { components = {} } = typeof window === 'undefined' ? {} : window.NikeDotcomNav;

  if (!components[id]) {
    // using defineProperty to prevent overwriting
    Object.defineProperty(components, id, {
      value: { id },
      enumerable: true,
    });
  }

  // called within component to apply the external properties
  return component => Object.assign(components[id], component);
};

export default useExternalComponents;
